import React, { useState } from "react";
import CartModal from "../../Components/CartModal";
import { useCart } from "../../Contexts/CartContext";
import PumpandCassettereplacementforPeripodL31200mls from "../../Assets/Bluelab-Replacement-Large-Pump-Cassette-1200ml-suitable_PUMPCONT-L_1.webp";
import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS

const Pump_and_Cassette_L3 = () => {
  const [showModal, setShowModal] = useState(false);
  const { addToCart } = useCart();

  const handleAddToCart = () => {
    const product = {
      id: 24,
      name: "Pump and Cassette replacement for Peripod L3 - 1200mls",
      price: 35028,
      image: PumpandCassettereplacementforPeripodL31200mls,
    };
    addToCart({ ...product, quantity: 1 });
    setShowModal(true);
  };

  return (
    <div className="container mt-3">
      {" "}
      {/* Add margin top to the container */}
      <div className="row">
        <div className="col-md-6">
          <div
            id="productCarousel"
            className="carousel slide"
            data-ride="carousel"
          >
            <div className="carousel-inner">
              <div className="carousel-item active">
                <img
                  src={PumpandCassettereplacementforPeripodL31200mls}
                  alt="Product 1"
                  className="d-block w-100"
                />
              </div>
              {/* Add more images to the carousel as needed */}
            </div>
            <a
              className="carousel-control-prev"
              href="#productCarousel"
              role="button"
              data-slide="prev"
            >
              <span
                className="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
              <span className="sr-only">Previous</span>
            </a>
            <a
              className="carousel-control-next"
              href="#productCarousel"
              role="button"
              data-slide="next"
            >
              <span
                className="carousel-control-next-icon"
                aria-hidden="true"
              ></span>
              <span className="sr-only">Next</span>
            </a>
          </div>
        </div>

        <div className="col-md-6">
          <div className="product-details">
            <h2 className="product-name">
              Pump and Cassette replacement for Peripod L3 - 1200mls
            </h2>
            <p className="product-price">₹{35028}</p>
            <button className="btn btn-primary" onClick={handleAddToCart}>
              Add to Cart
            </button>
            <p className="product-description mt-3">
              <ul>
                <li>PeriPod L3 compatibility only.</li>
                <li>
                  The Pump and Cassette replacement for PeriPod L3 delivers a
                  1200ml/min flow rate, ensuring efficient nutrient dosing.
                  Designed exclusively for L3 PeriPods, it provides reliable
                  performance for automated growing systems.
                </li>
              </ul>
            </p>
          </div>
        </div>
      </div>
      {/* Conditionally render the CartModal based on showModal */}
      {showModal && <CartModal onClose={() => setShowModal(false)} />}
    </div>
  );
};

export default Pump_and_Cassette_L3;
